module.exports = __webpack_public_path__ + "static/media/icon.5a84b6ff.png";